module.exports = __webpack_public_path__ + "static/banner-tablet-905d63bf541737803a433de139b5305d.png";